export const chartFilter = (
  dateField,
  subFilterField,
  subscriberFilter,
  subscriberIdFilter,
  selectedSub,
  dateFilter
) => {
  const now = new Date();
  now.setMinutes(0, 0, 0);

  const yesterday = new Date(now - 24 * 60 * 60 * 1000);

  const sinceMidnight = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0
  );

  const startOfYesterday = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate(),
    0,
    0
  );
  const endOfYesterday = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate(),
    23,
    59
  );

  const weekAgo = new Date(now - 24 * 60 * 60 * 7 * 1000);

  const monthAgo = new Date(now - 24 * 60 * 60 * 31 * 1000);

  const yearToDay = new Date(new Date().getFullYear(), 0, 1);

  const startOfLastYear = new Date(now.getFullYear() - 1, 0, 0, 23, 59);
  const endOfLastYear = new Date(now.getFullYear() - 1, 11, 31, 23, 59);

  let field = dateField;

  let filterSinceMidnight;
  let filterYest;
  let filterOneWeek;
  let filterOneMonth;
  let filterYearToDay;
  let filterLastYear;

  if (selectedSub !== 'Digital Conversation') {
    if (subFilterField === 'subscriberKey') {
      filterSinceMidnight = {
        [field]: { $gte: sinceMidnight },
        [subFilterField]: subscriberFilter,
      };
      filterYest = {
        [field]: { $gte: startOfYesterday, $lt: endOfYesterday },
        [subFilterField]: subscriberFilter,
      };
      filterOneWeek = {
        [field]: { $gte: weekAgo },
        [subFilterField]: subscriberFilter,
      };
      filterOneMonth = {
        [field]: { $gte: monthAgo },
        [subFilterField]: subscriberFilter,
      };
      filterLastYear = {
        [field]: { $gte: startOfLastYear, $lt: endOfLastYear },
        [subFilterField]: subscriberFilter,
      };
      filterYearToDay = {
        [field]: { $gte: yearToDay },
        [subFilterField]: subscriberFilter,
      };
    } else {
      filterSinceMidnight = {
        [field]: { $gte: sinceMidnight },
        [subFilterField]: subscriberIdFilter,
      };
      filterYest = {
        [field]: { $gte: startOfYesterday, $lt: endOfYesterday },
        [subFilterField]: subscriberIdFilter,
      };
      filterOneWeek = {
        [field]: { $gte: weekAgo },
        [subFilterField]: subscriberIdFilter,
      };
      filterOneMonth = {
        [field]: { $gte: monthAgo },
        [subFilterField]: subscriberIdFilter,
      };
      filterLastYear = {
        [field]: { $gte: startOfLastYear, $lt: endOfLastYear },
        [subFilterField]: subscriberIdFilter,
      };
      filterYearToDay = {
        [field]: { $gte: yearToDay },
        [subFilterField]: subscriberIdFilter,
      };
    }
  } else {
    filterSinceMidnight = { [field]: { $gte: sinceMidnight } };
    filterYest = { [field]: { $gte: startOfYesterday, $lt: endOfYesterday } };
    filterOneWeek = { [field]: { $gte: weekAgo } };
    filterOneMonth = { [field]: { $gte: monthAgo } };
    filterLastYear = { [field]: { $gte: startOfLastYear, $lt: endOfLastYear } };
    filterYearToDay = { [field]: { $gte: yearToDay } };
  }

  let chartFilter;

  switch (dateFilter) {
    case 'today':
      chartFilter = filterSinceMidnight;
      break;
    case 'yesterday':
      chartFilter = filterYest;
      break;
    case 'weekly':
      chartFilter = filterOneWeek;
      break;
    case 'monthly':
      chartFilter = filterOneMonth;
      break;
    case 'ytd':
      chartFilter = filterYearToDay;
      break;
    case 'yearly':
      chartFilter = filterLastYear;
      break;
    default:
      chartFilter = filterSinceMidnight;
  }

  return chartFilter;
};
